import { useFormContext } from "react-hook-form";
import { Controller } from "react-hook-form";
import { FormControl, InputLabel, Select, FormHelperText, MenuItem } from "@mui/material";
import FieldLabel from "./FieldLabel";

export default function FormControlSelect({ name, label, options, required, control: controlProps, ...props }) {
  const { control: controlContext } = useFormContext();
  const control = controlProps || controlContext;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => {
        const error = errors?.[name];
        return (
          <FormControl
            fullWidth
            error={!!error}
            // required={required}
          >
            <InputLabel id={`${name}-label`}>
              <FieldLabel
                label={label}
                required={required}
              />
            </InputLabel>
            <Select
              {...field}
              {...props}
              labelId={`${name}-label`}
              label={label}
            >
              {options?.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
}
